import { render } from "./OrderNoSearch.vue?vue&type=template&id=0dfedc11"
import script from "./OrderNoSearch.vue?vue&type=script&lang=js"
export * from "./OrderNoSearch.vue?vue&type=script&lang=js"
script.render = render

export default script